module.exports = __webpack_public_path__ + "/dist/assets/fonts/fa-brands-400.woff";